module.exports = __webpack_public_path__ + "static/media/Retensee.519abfa0.svg";